import COMMON_COUNTRY from "./common_countries.json"
import UNCOMMON_COUNTRIES from "./uncommon_countries.json"


export const countryData = [
    {
        label: '',
        options: COMMON_COUNTRY,
    },
    {
        label: 'others',
        options: UNCOMMON_COUNTRIES,
    },
];

export { COMMON_COUNTRY, UNCOMMON_COUNTRIES }
